<script>
import CompareRack from '@/components/containers/plp/CompareRack';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  components: {CompareRack, TrekButton, TrekLink},
};
</script>
